import { ThemeEvents } from '@theme/events';

/**
 * Bloco "Combina com" da página do produto.
 * Ao trocar de cor, o seletor de variantes busca a seção de novo e dispara `variant:update` com o HTML novo;
 * este elemento troca o próprio conteúdo pelo bloco equivalente desse HTML (as sugestões da nova cor).
 */
class CombinaCom extends HTMLElement {
  connectedCallback() {
    this.secao = this.closest('.shopify-section, dialog');
    this.secao?.addEventListener(ThemeEvents.variantUpdate, this.atualizar);
  }

  disconnectedCallback() {
    this.secao?.removeEventListener(ThemeEvents.variantUpdate, this.atualizar);
  }

  /** @param {Event & {detail?: any}} event */
  atualizar = (event) => {
    const dados = event.detail?.data;
    if (!dados?.html) return;
    if (dados.newProduct) {
      this.dataset.productId = dados.newProduct.id;
    } else if (dados.productId && dados.productId !== this.dataset.productId) {
      return;
    }

    const novo = dados.html.querySelector(`combina-com[data-block-id="${this.dataset.blockId}"]`);
    if (!novo) {
      this.hidden = true;
      this.replaceChildren();
      return;
    }
    this.hidden = novo.hasAttribute('hidden');
    this.replaceChildren(...Array.from(novo.childNodes, (no) => document.importNode(no, true)));
  };
}

if (!customElements.get('combina-com')) {
  customElements.define('combina-com', CombinaCom);
}
